import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { Link } from 'gatsby';
import ReactMarkdown from "react-markdown"
import rehypeRaw from 'rehype-raw'
import GETLINK from '../getlink'
/**
 * Components
 */
import TextColumns from '@components/text-columns/text-columns';

const HomeTextColumns = (props) => {
    const [isEnfieldPage, setIsEnfieldPage] = useState(false);
      useEffect(() => {
        if (typeof window !== "undefined" && window.location.pathname.indexOf("/contact/our-offices/") > -1) {
          setIsEnfieldPage(true);
        }
      }, []);
    return (
        <div className="static-text-columns two-col-wrapper">        
        <TextColumns>
            <Col xs={12} lg={4}>
                <ReactMarkdown rehypePlugins={[rehypeRaw]} children={props.ContentLeft}/>
                {props.childpages && props.childpages.length > 0 &&
                <ul className="child-pages">
                    {props.childpages.map((node, key) => {
                    return<>
                    {node.Child_Page_Custom_Link ?
                    <li data-aos="fade-right"><Link to={node.Child_Page_Custom_Link}>--- {node.Child_Page_Label}</Link></li>
                    :
                    <li data-aos="fade-right"><GETLINK label={node.Child_Page_Label} link={node.Child_Page_Link && node.Child_Page_Link.URL}/></li>
                    }
                    </>
                    })}
                </ul>
                }
            </Col>
            <Col xs={12} lg={{ span: 7, offset: 1 }}>
                <div className={`content ${isEnfieldPage ? "mt-0" : ""}`}>
                    <ReactMarkdown rehypePlugins={[rehypeRaw]} children={props.ContentRight}/>
                </div>
            </Col>
        </TextColumns>
        </div>
    )
}

export default HomeTextColumns
